import styled from 'styled-components';

import { colors, fontFamily } from '../../ui/variables';

export const CheckboxStyle = styled.div`
  width: 100%;

  .checkbox-wrapper {
    display: block;
    // margin-bottom: 24px;
    position: relative;
    user-select: none;

    &.checked {
      .checkbox-checkmark {
        background-color: ${colors.softBlue};
        border: 1px solid ${colors.softBlue};
      }
    }

    &.error-theme,
    &.with-error {
      &.checked {
        .checkbox-checkmark {
          border: 1px solid ${colors.softBlue};
        }
      }

      .checkbox-checkmark {
        border: 1px solid #ff00ff;
      }

      .checkbox-content {
        color: #ff00ff;
      }
    }

    &.with-error {
      margin-bottom: 0;
    }

    input[type='checkbox'] {
      display: none;
    }

    .checkbox-content {
      ${fontFamily.sourceSansPro.regular};
      color: ${colors.veryDarkGray};
      cursor: pointer;
      font-size: 14px;
      line-height: 18px;
      padding-left: 36px;

      a {
        ${fontFamily.sourceSansPro.bold};
      }
    }

    .checkbox-checkmark {
      border: 1px solid ${colors.grayishBlue};
      border-radius: 5px;
      cursor: pointer;
      display: block;
      height: 20px;
      left: 0;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      transition: background-color 200ms, border 200ms;
      width: 20px;

      &:before {
        background-color: ${colors.white};
        border-radius: 50%;
        content: '';
        height: 8px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
      }
    }
  }

  .checkbox-error {
    ${fontFamily.InputFieldStyle};
    background: transparent;
    border: none;
    color: #ff00ff;
    font-size: 12px;
    line-height: 20px;
    margin-bottom: 4px;
  }
`;
